<template>
    <div id="meta-leads-channel-detail">
        <AppBreadCrumb
            :paths="[{ title: 'Meta Leads Channel Detail' }]"
            :select="true"
            class="visitor-detail-bread-crumb"
        >
        </AppBreadCrumb>
        <div class="wrapper" v-if="channel">
            <div class="toolbar">
                <div class="left">
                    <IconButton :on-click="() => $router.push('/integrations/meta-leads')">
                        <span class="material-icons"> chevron_left </span>
                    </IconButton>
                    <div class="icon-container">
                        <MetaIcon />
                    </div>
                    <div class="name">{{$t("message.metaLeadsChannel")}} : {{ channel.name }}</div>
                </div>
                <div class="right">
                    <a-button type="danger" @click="deleteModal = true"
                        >{{ $t("whatsappChannel.deleteChannel") }}
                    </a-button>
                </div>
            </div>
            <div class="channel-content">
                <div class="left">
                    <ChannelMenu v-model="currentTab" />
                </div>
                <div class="page-content">
                    <div v-if="currentTab === MetaLeadsMenuTypes.CHANNEL.id">
                        <UpdateDetail v-model="channel" />
                    </div>
                    <div v-if="currentTab === MetaLeadsMenuTypes.VISIBILITY.id">
                        <Visibility v-model="channel" />
                    </div>
                    <div v-if="currentTab === MetaLeadsMenuTypes.LEADS.id && channel">
                        <LeadList
                            :channel="channel"
                            :channel-id="channel._id"
                            :form-mode="!!selectedFormId"
                            :form-id="selectedFormId"
                        />
                    </div>
                    <div v-if="currentTab === MetaLeadsMenuTypes.FORMS.id && channel">
                        <FormList
                            :channel="channel"
                            :channel-id="channel._id"
                            @showFormLeads="(form) => showFormLeads(form)"
                        />
                    </div>
                </div>
            </div>
        </div>

        <a-modal
            v-model="deleteModal"
            icon="exclamation-circle"
            :title="$t('instagram.channel')"
            @cancel="deleteModal = false"
        >
            <p>{{ $t("whatsappChannel.deleteChannel") }}</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteMetaLeadChannel">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>
    </div>
</template>
<script>
import Vue from "vue";
import SettingsMultiWhatsapp from "../../../WhatsappV1/SettingsMultiWhatsapp.vue";
import IconButton from "../../../Settings/components/IconButton.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { sendSocketMessage, socketMessageStream } from "../../../../../utils/socketStream";
import _ from "lodash";
import ChannelMenu from "./ChannelMenu.vue";
import Visibility from "./Visibility.vue";
import log2 from "../../../../../utils/log2";
import MetaLeadsMenuTypes from "./MetaLeadsMenuTypes";
import UpdateDetail from "./UpdateDetail.vue";
import SYSTEM_PUBSUB from "../../../../../utils/systemPubSub";
import { filter, first, timeout } from "rxjs/operators";
import AppBreadCrumb from "../../../../../components/common/AppBreadCrumb.vue";
import IGCommentManagement from "./IGCommentManagement.vue";
import MetaIcon from "../../../Chatbot/pages/integrations/svg/MetaIcon.vue";
import LeadList from "../LeadList.vue";
import FormList from "../FormList.vue";
import ChatWatcher from "../../../../../ChatWatcherV2";

const log = log2("MetaLeadsChannelDetail.vue");
export default Vue.extend({
    name: "MetaLeadsChannelDetail",
    components: {
        FormList,
        LeadList,
        MetaIcon,
        UpdateDetail,
        Visibility,
        ChannelMenu,
        IconButton,
        SettingsMultiWhatsapp,
        AppBreadCrumb,
        IGCommentManagement,
    },
    data() {
        const path = (_.last(this.$route.path.split("/")) || "detail").toLowerCase().trim();
        const selected = Object.values(MetaLeadsMenuTypes).find((x) => x.path === path);
        return {
            currentTab: selected ? selected.id : "detail",
            loading: false,
            selectedChannelId: this.$route.params.id,
            deleteModal: false,
            channel: null,
            MetaLeadsMenuTypes,
            visible: this.$route.query.action == "start-chat",
            confirmLoading: false,
            whatsappNumber: "",
            showAlertMessage: false,
            dialCode: "+90",
            selectedFormId: null,
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            channels: (state) => state.channel.channels.filter((x) => x.type === "meta-leads"),
            userLastCountry: (state) => _.get(state.auth.user, "lastGeoLocation.country"),
            siteId: (state) => _.get(state.site.site, "_id"),
            user: (state) => state.auth.user,
            socketConnected: (state) => state.socketStatus.socket_connected,
            site: (state) => state.site.site,
        }),
        ...mapGetters({
            myActiveConversations: "chat/getMyActiveConversations",
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
            listChannels: "channel/listChannels",
            deleteChannel: "channel/deleteChannel",
            updateChannel: "channel/updateChannel",
        }),
        showFormLeads(form) {
            console.log("showFormLeads", form);
            this.selectedFormId = form.formId;
            this.currentTab = MetaLeadsMenuTypes.LEADS.id;
        },
        changePage(page) {
            this.currentTab = page;
        },
        toggleChatbot() {
            if (this.showStories) {
                this.form.forward.story = null;
            } else {
                if (this.stories[0]) {
                    this.form.forward.story = this.stories[0]._id;
                }
            }
            this.showStories = !this.showStories;
        },
        deleteMetaLeadChannel() {
            const channel = this.channel;
            this.deleteChannel(channel._id).then(() => {
                this.$router.push("/integrations/meta-leads");
            });
        },
        handleSave() {
            const isValid = true;
            if (isValid) {
                const payload = this.channel;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success(this.$t("message.channelUpdatedSucs"));
                        this.originalChannel = _.cloneDeep(this.channel);
                        this.$emit("ok");
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error(this.$t("message.failedUpdateChannel"));
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        handleCancel() {
            this.visible = false;
            this.confirmLoading = false;
            this.whatsappNumber = "";
            this.showAlertMessage = false;
        },
        onSelect(value) {
            log("onSelect", value);
            this.dialCode = value.dialCode;
        },
        startChat(whatsappNumber) {
            whatsappNumber = whatsappNumber || "";
            log("startChat", { whatsappNumber });
            whatsappNumber = this.dialCode + whatsappNumber;
            ChatWatcher.startChatImmediately({
                whatsappNumber,
                channelId: this.channel._id,
                channelType: "instagram",
            });
        },
    },
    mounted() {
        this.listChannels().then((channels) => {
            this.channel = channels.find((x) => x._id === this.selectedChannelId);
            this.originalChannel = _.cloneDeep(this.channel);
        });
    },
    watch: {
        channel: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.originalChannel);
                    if (isChanged) {
                        log("channel changed=>", val);
                        this.handleSave();
                    }
                }
            },
            deep: true,
        },
        currentTab(value) {
            const selected = Object.values(MetaLeadsMenuTypes).find((x) => x.id === value);
            if (selected) {
                this.$router.push(`/integrations/meta-leads/${this.channel._id}/detail/${selected.path}`);
            }
        },
    },
});
</script>

<style scoped lang="scss">
#meta-leads-channel-detail {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        .toolbar {
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            border: 1px solid var(--color-border-default);

            .left {
                display: flex;
                align-items: center;
                gap: 5px;

                .name {
                    font-size: 18px;
                    font-weight: 700;
                }

                .icon-container {
                    width: 30px;
                    height: 30px;
                    display: flex;
                    margin: 0 auto;
                    align-items: center;
                    justify-content: center;
                    border-radius: 6px;
                    overflow: hidden;
                    position: relative;
                }
            }

            .right {
                display: flex;
                justify-content: flex-end;
                gap: 5px;
            }
        }

        .channel-content {
            display: flex;
            height: 100%;

            .left {
                width: 275px;
                height: 100%;

                .channel-menu {
                    width: 100%;
                }
            }

            .page-content {
                width: calc(100% - 275px);
                height: 100%;
            }
        }
    }
}
</style>
